// extracted by mini-css-extract-plugin
export default {"circle":"BNYq1t","rotate":"SihGV_","clip":"LA6XzO","clip-reverse":"Tygtjj","clipReverse":"Tygtjj"};